import React, { Fragment, useEffect, useState } from 'react'
import MasterComponentWraper from '../../Backend/MasterComponentWraper';
import NavigationHeder from '../../Navigations/NavigationHeder';
import LinkBtn from '../../inc/LinkBtn';
import Button from '../../inc/Button';
import SimpleLoading from '../../Loading/SimpleLoading';
import { useParams } from 'react-router-dom';
import FormValidator from '../../../inc/FormValidator';
import Api from '../../../inc/Api';
import Settings from '../../../inc/Settings';
import Collapse from '../../inc/Collapse';
import FieldsRenderer from '../../Purchase Orders Internal/Edit PO/FieldsRenderer';
import { areObjectsDifferent, getPopupMessageBasedOnStatus } from '../../../inc/Validation';
import Helper from '../../../inc/Helper';
import CommonAPICalls from "../Common Integration Calls/CommonApiCalls";

let defaultOperationMappingFormsObject = null;
const OperationMappingFormsDetailView = () => {
    const [operationMappingFormsData, setOperationMappingFormsData] = useState({});

    const [apiMaster, setApiMaster] = useState([]);
    const [sources, setSources] = useState([]);

    const [loading, setLoading] = useState(true); 

    const { id } = useParams();

    let getByIdApiCall = false; 

    useEffect(() => {  
        getOperationMappingFormsById();
        fetchDataForSystemDetails();
    }, []);

    let validator;
  
    const validationConfigure = () => {
        let fieldConfig = [
            { name: "operation_name", displayName: "Name", types: ["Required"] },
            { name: "parameters", displayName: "Parameters", types: ["Required"] },
            { name: "response_type", displayName: "Response type", types: ["Required"] }, 
            { name: "api", displayName: "Api", types: ["Required"] },
            { name: "source", displayName: "Source", types: ["Required"] } 
        ];
  
        if(!validator) {
            validator = new FormValidator(fieldConfig)
        }
    }
  
    validationConfigure()
   
    const fetchDataForSystemDetails = async () => {
        const apiCalls = new CommonAPICalls();
        try {
            const systemApiMasterResponse = await apiCalls.getSystemApiDetails();
            const systemSourcesResponse = await apiCalls.getSystemSourceMaster();
        
            if (systemApiMasterResponse) {
                setApiMaster(systemApiMasterResponse);
            };
            if(systemSourcesResponse) {
                setSources(systemSourcesResponse);
            };
        } catch (error) { 
            setApiMaster([]); 
            setSources([]);
        }
    }

    const getOperationMappingFormsById = () => { 
        if(getByIdApiCall) return;
    
        getByIdApiCall = true;
        setLoading(true);
    
        let api = Api;
        api.setUserToken()
        api.axios().get(Settings.apiAppUrl+`/operation-mapping/${id}/`,{}).then(function(res){
            if(res?.status === 200){ 
                setOperationMappingFormsData(res?.data);
                defaultOperationMappingFormsObject = res?.data;
                setLoading(false);
            } else {
                Helper.alert(res?.data?.message, 'error')
            }
        }).catch((res) => { 
            getPopupMessageBasedOnStatus(res) 
            setLoading(false)
        })
    }

    const OperationMappingForms = () => { 
        let textBoxInputSettings = [
            {
                className: "col-lg-4",
                label: "Operation name",
                required: true,
                inputType: "text",
                id: "operation_name",
                name: "operation_name"
            },
            {
                className: "col-lg-4",
                label: "Parameters",
                required: true,
                inputType: "text",
                id: "parameters",
                name: "parameters"
            },
            {
                className: "col-lg-4",
                label: "Response type",
                required: true, 
                inputType: "text",
                id: "response_type",
                name: "response_type"
            }, 
            {
                className: "col-lg-4",
                label: "is Active", 
                inputType: "checkbox",
                id: "is_active",
                name: "is_active"
            },
            {
                className: "col-lg-4",
                label: "Api",
                inputType: "dropdown",
                options: apiMaster,
                required: true, 
                id: "api",
                name: "api"
            }, 
            {
                className: "col-lg-4",
                label: "Source",
                inputType: "dropdown",
                options: sources,
                required: true, 
                id: "source",
                name: "source"
            }
        ];

        return (
            <Collapse open={true} title={"General"}>
                <div className='row mb-3'>
                    <FieldsRenderer fieldsArray={textBoxInputSettings} updateState={setOperationMappingFormsData} currentState={operationMappingFormsData} />
                </div>
            </Collapse>
        )
    }
  
    const SaveHandler = () => {
        if(!areObjectsDifferent(defaultOperationMappingFormsObject, operationMappingFormsData)) return;
        
        let validData = {
            ...operationMappingFormsData
        };
    
        if(!validator.isValid(validData)){
            validator.displayMessage();
            validator.reset() 
            return;
        };
    
        let api = Api;
        api.setUserToken();
    
        api.axios().put(Settings.apiAppUrl+`/operation-mapping/${id}/`, {
            ...operationMappingFormsData,
            is_active: operationMappingFormsData.is_active == 'on'
        }).then(function(res){
            if(res?.status === 200){
                Helper.alert(res?.data?.message || 'Operation mapping updated successfully', 'success');
                getOperationMappingFormsById();
            } else {
                Helper.alert(res?.data?.message, 'error')
            }
        }).catch((res) => {  
            getPopupMessageBasedOnStatus(res);
        })  
    }

    return (
        <div className='container-fluid'>
            <NavigationHeder title={ `<span style="color:#000;"> Edit Operation Mapping #</span> ${operationMappingFormsData.operation_name}` }>
                <LinkBtn to={-1} isActive= {false} title={"Close"} />
                <Button isActive= {true} onClick ={SaveHandler} title={"Save"} icon={'/images/icons/save-white.svg'} />
            </NavigationHeder>
    
            {loading ? <SimpleLoading /> : (
                <Fragment>
                    {OperationMappingForms()} 
                </Fragment>
            )} 
        </div>
    )
}

export default (MasterComponentWraper(OperationMappingFormsDetailView));